import type { AuthOptions } from '@aws-amplify/auth/lib-esm/types';
import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { isPlatform } from '@ionic/react';
import { Auth } from 'aws-amplify';

// Uncomment for Amplify library debugging.
// import { Logger } from 'aws-amplify';
// Logger.LOG_LEVEL = 'DEBUG';

const REGION = process.env.REACT_APP_REGION;
const USER_POOL_ID = process.env.REACT_APP_USER_POOL_ID;
const APP_CLIENT_ID = process.env.REACT_APP_APP_CLIENT_ID;
const GUEST_POOL_ID = process.env.REACT_APP_GUEST_POOL_ID;
const GUEST_POOL_CLIENT_ID = process.env.REACT_APP_GUEST_POOL_CLIENT_ID;
const HOSTED_UI_URL = process.env.REACT_APP_COGNITO_HOSTED_UI_URL;
const LOCAL_URL = process.env.REACT_APP_LOCAL_URL;
const MOBILE_CUSTOM_SCHEMA_URL = 'com.stoneagetools.sentinel-link://';

const urlOpener = async (url: string, redirectUrl: string) => {
  let didOpen: Promise<void> | undefined;
  if (isPlatform('hybrid')) {
    didOpen = new Promise<void>((res, rej) => {
      const closeHandle = Browser.addListener('browserFinished', async () => {
        await Promise.allSettled([urlHandle.then(r => r.remove()), closeHandle.then(r => r.remove())]);
        res();
      });
      const urlHandle = App.addListener('appUrlOpen', async data => {
        try {
          await (Auth as any)._handleAuthResponse(data.url);
        } catch {} // expected on mobile
        try {
          await Promise.allSettled([
            Browser.close(),
            urlHandle.then(r => r.remove()),
            closeHandle.then(r => r.remove()),
          ]);
          res();

          const redirectPath = redirectUrl.replace(MOBILE_CUSTOM_SCHEMA_URL, '/');
          window.location.href = redirectPath;
        } catch (e) {
          rej(e);
        }
      });
    });
  }

  await Browser.open({ url, windowName: '_self' });
  if (didOpen) await didOpen; // If mobile, prevent promise from resolving until the oauth flow is actually complete
};

const authConfig: AuthOptions = {
  region: REGION,
  userPoolId: USER_POOL_ID,
  userPoolWebClientId: APP_CLIENT_ID,
  identityPoolId: '',
  mandatorySignIn: true,
  oauth: {
    domain: HOSTED_UI_URL!,
    scope: ['openid', 'email', 'profile'],
    redirectSignIn: isPlatform('hybrid') ? `${MOBILE_CUSTOM_SCHEMA_URL}welcome` : `${LOCAL_URL}/welcome`,
    redirectSignOut: isPlatform('hybrid') ? `${MOBILE_CUSTOM_SCHEMA_URL}logout` : `${LOCAL_URL}/logout`,
    /* Response type 'code' allows hosted UI to return a refresh token, which in turn allows the app to refresh its auth token silently. */
    responseType: 'code',
    urlOpener,
  },
};

export const config = {
  aws_project_region: REGION,
  aws_cognito_identity_pool_id: 'null',
  aws_cognito_region: REGION,
  aws_user_pools_id: USER_POOL_ID,
  aws_user_pools_web_client_id: APP_CLIENT_ID,
  Auth: authConfig,
};

export const jobReportShareConfig = {
  aws_project_region: REGION,
  aws_cognito_identity_pool_id: 'null',
  aws_cognito_region: REGION,
  aws_user_pools_id: GUEST_POOL_ID,
  aws_user_pools_web_client_id: GUEST_POOL_CLIENT_ID,
};
